import { zhCN } from "date-fns/locale"
import { Calendar, X } from "lucide-react"
import React from "react"
import ReactDatePicker, { registerLocale } from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import "../../assets/styles/datepicker.css"

// 注册中文语言包
registerLocale("zh-CN", zhCN)

interface DatePickerProps {
  label: string
  value?: string // YYYY-MM-DD format
  onChange: (date: string) => void
  placeholder?: string
  disabled?: boolean
  required?: boolean
  minDate?: string // YYYY-MM-DD format, minimum selectable date
  className?: string
}

const DatePicker: React.FC<DatePickerProps> = ({
  label,
  value,
  onChange,
  placeholder = "请选择日期",
  disabled = false,
  required = false,
  minDate,
  className = ""
}) => {
  // Convert string to Date object
  const selectedDate = value ? new Date(value) : null

  // Handle date change and convert back to YYYY-MM-DD format
  const handleDateChange = (date: Date | null) => {
    if (date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      onChange(`${year}-${month}-${day}`)
    } else {
      onChange("")
    }
  }

  return (
    <div className={`space-y-2 ${className}`}>
      <label className="block text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      
      <div className="relative">
        <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none z-10" />
        <ReactDatePicker
          selected={selectedDate}
          onChange={handleDateChange}
          disabled={disabled}
          placeholderText={placeholder}
          dateFormat="yyyy年MM月dd日"
          className={`
            w-full pl-10 ${!required && value ? 'pr-8' : 'pr-3'} py-2 border border-gray-300 rounded-md
            focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
            disabled:bg-gray-100 disabled:cursor-not-allowed
            ${!value ? 'text-gray-400' : 'text-gray-900'}
          `}
          wrapperClassName="w-full"
          popperClassName="z-9999"
          showPopperArrow={false}
          fixedHeight
          locale="zh-CN"
          todayButton="今天"
          isClearable={false} // 禁用默认清除按钮
          showYearDropdown
          showMonthDropdown
          dropdownMode="select"
          calendarStartDay={1} // 星期一开始
          minDate={minDate ? new Date(minDate) : undefined}
        />
        {!required && value && (
          <button
            type="button"
            onClick={() => onChange("")}
            className="absolute right-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors z-10"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
      
    
    </div>
  )
}

export default DatePicker